export const th = {
  common: {
    reserve: "จองที่นั่ง",
    birthdayWall: "บอร์ดอวยพร",
    backHome: "กลับหน้าแรก",
    loading: "กำลังโหลด…",
    seatsLeft: "เหลือ {n} ที่",
    full: "เต็มแล้ว",
    sets: "เซ็ต",
    guests: "ท่าน",
    person: "ท่าน",
    cancel: "ยกเลิก",
    close: "ปิด",
    submit: "ส่งข้อมูล",
    required: "จำเป็นต้องกรอก",
    openMap: "เปิดแผนที่",
    minutes: "นาที",
    save: "บันทึก",
  },
  nav: {
    schedule: "กำหนดการ",
    giveaways: "ของแถม",
    notes: "สิ่งที่ต้องรู้",
    faq: "คำถามที่พบบ่อย",
    location: "สถานที่",
    wall: "บอร์ดอวยพร",
    reserve: "จองที่นั่ง",
  },
  hero: {
    badge: "HBD Bogummy · 16/6/2026",
    title: "Park Bo-gum 박보검\nHappy Birthday 2026",
    subtitle: "Let’s enjoy Sandwich Birthday Party",
    venue: "ที่ Gumm&Kalee Café",
    dateRange: "14–16 มิถุนายน 2569",
    intro:
      "ร่วมฉลองวันเกิดพัคโบกอมกับงานสุดพิเศษ 3 วัน วันละ 3 รอบ — กรุณาอ่านรายละเอียดให้ครบถ้วนก่อนจองที่นั่ง",
    cta: "จองที่นั่งเลย",
    ctaWall: "เขียนอวยพร",
  },
  schedule: {
    title: "กำหนดการ 3 วัน",
    subtitle: "วันที่ 14–16 มิ.ย. 2569 · วันละ 3 รอบ · นั่งได้ถึงเวลาจบรอบเท่านั้น",
    roundWord: "รอบ",
    checkIn: "ยืนยันคิวเข้าร้าน",
    quotaBadgeN: "สั่งซื้อ {n} เซ็ตแรก รับ Special Giveaway",
    luckyBadge: "ซื้อ 2 เซ็ต ลุ้นรับของรางวัล",
    seeReserve: "เลือกจองรอบนี้",
  },
  giveaway: {
    title: "ของแถม & ของรางวัล",
    specialTitle: "Special Giveaway",
    specialDesc:
      "Special Giveaway สำหรับผู้ที่สั่งซื้อเป็นลำดับต้นๆ ของแต่ละรอบ — วันที่ 14 มิ.ย. 20 เซ็ตแรกต่อรอบ, วันที่ 15 และ 16 มิ.ย. 10 เซ็ตแรกต่อรอบ (เรียงลำดับจากการสั่งซื้อและชำระเงินที่หน้าร้านเท่านั้น มีการแจกบัตรคิวที่หน้าร้านล่วงหน้า 30 นาทีก่อนแต่ละรอบ และไม่เกี่ยวกับการลงทะเบียนล่วงหน้า)",
    luckyTitle: "ลุ้นรับของรางวัล (ซื้อ 2 เซ็ต)",
    luckyDesc: "ซื้อครบ 2 เซ็ต รับสิทธิ์ลุ้นรับของรางวัลพิเศษประจำวัน",
    perDayTitle: "ของรางวัลประจำวัน",
    shirt: "เสื้อ Be with You (ของแท้) 1 ตัว",
    ginseng: "Everytime Red Ginseng 1 กล่อง พร้อม Postcard",
    shampoo: "Dr.Forhair Shampoo Limited Edition Pokémon",
    dayWord: "วันที่",
  },
  notes: {
    title: "สิ่งที่ต้องรู้ก่อนมางาน",
    items: [
      "เปิดให้ยืนยันการลงทะเบียนเพื่อเตรียมเข้าร้าน ก่อนรอบเวลา 30 นาที (08.30 / 11.30 / 14.30 น.)",
      "ในแต่ละรอบ ขอให้ผู้เข้าร่วมงานมาตรงเวลา มาสายได้ไม่เกิน 30 นาที หลังจากนั้นจะตัดสิทธิ์และให้ลูกค้า walk-in หน้าร้านแทน (หากยังมีที่นั่งว่างในร้าน)",
      "ขอความร่วมมือผู้เข้าร่วมงานแต่ละรอบ นั่งในร้านและร่วมกิจกรรมได้ตามเวลาที่กำหนดของแต่ละรอบเท่านั้น",
      "Sandwich Birthday Set 1 เซ็ต ต่อ 1 ท่าน (จำนวนที่นั่ง = จำนวนเซ็ต)",
      "ทางร้านขอเคลียพื้นที่ในแต่ละรอบ เพื่อให้สิทธิ์ผู้เข้าร่วมงานรอบถัดไปเข้ามาใช้พื้นที่ในร้าน",
    ],
  },
  faq: {
    title: "คำถามที่พบบ่อย",
    items: [
      { q: "ต้องจองที่นั่งล่วงหน้าไหม?", a: "แนะนำให้จองล่วงหน้าเพื่อรับรองที่นั่ง ส่วนลูกค้า walk-in รับได้หลังเริ่มรอบ 30 นาทีหากมีที่ว่าง" },
      { q: "การจองที่นั่งเกี่ยวกับ Special Giveaway ไหม?", a: "การจองที่นั่งแต่ละรอบเป็นเพียงการจัดการระบบภายในร้านเพื่ออำนวยความสะดวกให้ผู้เข้าร่วมงานเท่านั้น ไม่เกี่ยวกับการสั่งซื้อ Sandwich Set หรือการรับสิทธิ์ Special Giveaway" },
      { q: "1 การจองจองได้กี่ที่?", a: "ระบุจำนวนผู้เข้าร่วม (= จำนวนเซ็ต) ได้ตามต้องการ โดย 1 เซ็ตต่อ 1 ท่าน" },
      { q: "มีค่าใช้จ่ายในการจองไหม?", a: "การจองที่นั่งไม่มีค่าใช้จ่ายหรือค่ามัดจำใดๆ เป็นเพียงการสำรองที่นั่งเพื่อให้ทางร้านคำนวณจำนวนผู้เข้าร่วมและเตรียมสินค้าให้เพียงพอในแต่ละรอบ" },
      { q: "ยกเลิก/แก้ไขการจองอย่างไร?", a: "กดลิงก์ในอีเมลยืนยัน เพื่อดูหรือยกเลิกการจอง การยกเลิกจะคืนที่นั่งให้ผู้อื่นทันที" },
      { q: "ไม่ได้รับอีเมลยืนยัน?", a: "ตรวจสอบกล่อง Junk/Spam หรือบันทึกรหัสจองหน้าจอไว้ และติดต่อทีมงานเพื่อส่งอีเมลอีกครั้งได้" },
    ],
  },
  location: {
    title: "สถานที่จัดงาน",
    cafe: "Gumm&Kalee Café",
    desc: "ดูเส้นทางและตำแหน่งร้านได้จาก Google Maps",
    button: "เปิดใน Google Maps",
  },
  reserve: {
    title: "จองที่นั่ง",
    subtitle: "กรอกข้อมูลเพื่อจองที่นั่งร่วมงาน เราจะส่งอีเมลยืนยันให้คุณ",
    name: "ชื่อ-นามสกุล",
    phone: "เบอร์โทรศัพท์",
    email: "อีเมล",
    emailHint: "ใช้รับอีเมลยืนยันการจอง",
    partySize: "จำนวนผู้เข้าร่วม (เซ็ต)",
    day: "เลือกวัน",
    round: "เลือกรอบเวลา",
    pickDayFirst: "กรุณาเลือกวันก่อน",
    submit: "ยืนยันการจอง",
    submitting: "กำลังจอง…",
    selectRound: "— เลือกรอบ —",
    maxPartyNote: "สูงสุด {n} ท่านต่อการจอง",
    errors: {
      name: "กรุณากรอกชื่อ",
      phone: "กรุณากรอกเบอร์โทรให้ถูกต้อง",
      email: "กรุณากรอกอีเมลให้ถูกต้อง",
      slot: "กรุณาเลือกวันและรอบเวลา",
      turnstile: "กรุณายืนยันว่าไม่ใช่บอท",
      full: "ขออภัย รอบนี้ที่นั่งเต็มแล้ว กรุณาเลือกรอบอื่น",
      generic: "เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง",
    },
    successTitle: "จองสำเร็จ!",
    successDesc: "เราได้ส่งอีเมลยืนยันไปให้คุณแล้ว กรุณาบันทึกรหัสจองนี้ไว้",
    yourCode: "รหัสจองของคุณ",
    emailSent: "ส่งอีเมลยืนยันให้แล้ว",
    emailSkipped: "ระบบอีเมลยังไม่เปิดใช้งาน — กรุณาบันทึกรหัสจองไว้",
    emailFailed: "ส่งอีเมลไม่สำเร็จ — กรุณาบันทึกรหัสจองไว้ และติดต่อทีมงาน",
    manageLink: "ลิงก์จัดการ/ยกเลิกการจอง",
    reserveAnother: "จองอีกรอบ",
    screenshotTip: "บันทึกรูป QR หรือแคปหน้าจอนี้ไว้แสดงในวันงาน",
    saveImage: "บันทึกรูป QR",
    qrHint: "สแกนหรือบันทึก QR นี้เพื่อเปิดการจองของคุณ",
  },
  manage: {
    title: "การจองของคุณ",
    status: "สถานะ",
    confirmed: "ยืนยันแล้ว",
    cancelled: "ยกเลิกแล้ว",
    cancelBtn: "ยกเลิกการจอง",
    cancelling: "กำลังยกเลิก…",
    cancelConfirm: "ยืนยันการยกเลิกการจองนี้? ที่นั่งจะถูกคืนให้ผู้อื่น",
    cancelledMsg: "ยกเลิกการจองเรียบร้อยแล้ว ขอบคุณค่ะ",
    notFound: "ไม่พบการจองนี้ ลิงก์อาจไม่ถูกต้อง",
  },
  wall: {
    title: "บอร์ดอวยพรวันเกิด",
    subtitle: "ส่งรูปภาพหรือข้อความอวยพรพัคโบกอม โพสต์จะแสดงบนบอร์ดในร้านหลังทีมงานตรวจสอบ",
    nameLabel: "ชื่อของคุณ (ไม่บังคับ)",
    messageLabel: "ข้อความอวยพร",
    photoLabel: "แนบรูปภาพ (ไม่บังคับ)",
    choosePhoto: "เลือกรูปภาพ",
    post: "ส่งคำอวยพร",
    posting: "กำลังส่ง…",
    pendingMsg: "ส่งสำเร็จ! โพสต์ของคุณจะแสดงบนบอร์ดหลังทีมงานตรวจสอบ",
    emptyErr: "กรุณาใส่ข้อความหรือแนบรูปภาพ",
    emptyGallery: "ยังไม่มีคำอวยพรที่แสดง — มาเป็นคนแรกกันเถอะ!",
    galleryTitle: "คำอวยพรล่าสุด",
    seeAll: "ดูคำอวยพรทั้งหมด",
    rateLimited: "คุณส่งบ่อยเกินไป กรุณารอสักครู่",
    tooLarge: "ไฟล์รูปใหญ่เกินไป",
  },
  wishes: {
    title: "คำอวยพรทั้งหมด",
    sortLatest: "ล่าสุด",
    sortLiked: "ถูกใจมากสุด",
    empty: "ยังไม่มีคำอวยพรที่แสดง — มาเป็นคนแรกกันเถอะ!",
    end: "ดูครบทุกคำอวยพรแล้ว 💛",
    likeRateLimited: "กดถูกใจถี่เกินไป กรุณารอสักครู่",
  },
  admin: {
    title: "Admin · ระบบจัดการงาน",
    password: "รหัสผ่าน",
    login: "เข้าสู่ระบบ",
    loggingIn: "กำลังเข้าสู่ระบบ…",
    badPassword: "รหัสผ่านไม่ถูกต้อง",
    logout: "ออกจากระบบ",
    tabStats: "ภาพรวมที่นั่ง",
    tabReservations: "การจอง",
    tabWall: "ตรวจบอร์ดอวยพร",
    tabTools: "เครื่องมือ",
    totalBookings: "การจองทั้งหมด",
    totalGuests: "ผู้เข้าร่วมทั้งหมด",
    slot: "รอบ",
    booked: "จองแล้ว",
    remaining: "ว่าง",
    capacity: "ความจุ",
    bookings: "ครั้ง",
    quota: "โควต้าของแถม",
    search: "ค้นหา ชื่อ/เบอร์/อีเมล/รหัส",
    filterSlot: "ทุกวัน/รอบ",
    exportCsv: "ดาวน์โหลด CSV",
    name: "ชื่อ",
    phone: "เบอร์",
    email: "อีเมล",
    size: "เซ็ต",
    status: "สถานะ",
    emailStatus: "อีเมล",
    actions: "จัดการ",
    resend: "ส่งอีเมลซ้ำ",
    save: "บันทึก",
    edit: "แก้ไข",
    pending: "รอตรวจสอบ",
    approved: "อนุมัติแล้ว",
    rejected: "ปฏิเสธ",
    approve: "อนุมัติ",
    reject: "ปฏิเสธ",
    noPending: "ไม่มีโพสต์รอตรวจสอบ",
    wallQrTitle: "QR สำหรับบอร์ดอวยพร",
    wallQrDesc: "ปริ้นต์ติดในร้าน ให้ลูกค้าสแกนเพื่อส่งคำอวยพร",
    boardLink: "เปิดหน้าจอบอร์ด (สำหรับขึ้นจอ)",
    downloadQr: "ดาวน์โหลด QR",
    boardSettings: "ตั้งค่าหน้าจอบอร์ด",
    boardSettingsDesc: "ตั้งเวลาสลับระหว่างโหมดการ์ดเดี่ยวและโหมดกำแพงการ์ด",
    boardCardMinutes: "โหมดการ์ดเดี่ยว (นาที)",
    boardWallMinutes: "โหมดกำแพงการ์ด (นาที)",
    boardCardAdvance: "สลับการ์ดทุก (วินาที)",
    saveSettings: "บันทึกการตั้งค่า",
    settingsSaved: "บันทึกแล้ว",
  },
  board: {
    empty: "รอคำอวยพรแรก… สแกน QR เพื่อร่วมส่งความสุข",
    scanToPost: "สแกนเพื่อส่งคำอวยพร",
  },
  footer: {
    unofficial: "งานแฟนเมดอย่างไม่เป็นทางการ",
    developedBy: "พัฒนาโดย",
  },
} as const;
